
class Stack {
  constructor(maxSize) {
    this.stack = [];
    this.maxSize = maxSize;
  }

  push(item) {
    if (this.stack.length >= this.maxSize) {
      this.stack.shift();
    }
    this.stack.push(item);
  }

  getItems() {
    return this.stack;
  }
}

function addProductToRecentlyViewed(product) {
  const maxItems = 24;
  const stack = new Stack(maxItems);

  const storedProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
  storedProducts.forEach((item) => stack.push(item));
  const productExists = storedProducts.some((item) => item.id === product.id);

  if (!productExists) {
    stack.push(product);
  }

  localStorage.setItem('recentlyViewed', JSON.stringify(stack.getItems()));
}

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
    const container = document.querySelector('.swiper-wrapper-recently-viewed');
    if (recentlyViewed.length === 0) {
      container.innerHTML = '<p>No recently viewed products yet.</p>';
    } else {
      
      document.querySelector('.recently-viewed-wrap').style.display = 'block';
      container.innerHTML = recentlyViewed
        .reverse()
        .map(
          (product) => `
              <div class="swiper-slide recently-viewed-item">
                <div class="flex gap-[16px] relative max-w-[320px] w-full">
                  <div class=" w-[113px]">
                    <img src="${product.image}" alt="${product.title}" class="h-auto  object-cover w-full" />
                  </div>
                  <div class="flex-1 flex flex-col gap-[10px]">
                    <h3 class="line-clamp-1	text-[#FFF] font-synthese text-[20px]  font-normal  tracking-[1.2px] m-0">${product.title}</h3>
                    <p class="line-clamp-1	 font-synthese text-[14px] m-0 font-light leading-[150%]">${product.description}</p>
                    <a href="${product.url}" class="recently-price after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full">$${product.price}</a>
                  </div>
                </div>
              </div>
          `
        )
        .join('');

      new Swiper('.recently-viewed-swiper', {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          0: {
            slidesPerView: 1.5,
          },
          390: {
            slidesPerView: 1.5,
          },
          600: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
        navigation: {
          nextEl: ".recently-swiper-button-next",
          prevEl: ".recently-swiper-button-prev",
        },
      });
    }
    document.querySelector('.swiper-wrapper-recently-viewed').appendChild(container);
  }
}

customElements.define('recently-viewed', RecentlyViewed);
